//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
// import './style.scss';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';

function Page() {
  const atThisMoment = useStore((state) => state.atThisMoment);
  const setAtThisMoment = useStore((state) => state.setAtThisMoment);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.atThisMoment.title')}</Title>
        <Text size='m' medium className={'description'} style={{ padding: 0 }}>
          {t('onboarding.atThisMoment.subTitle')}
        </Text>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={atThisMoment}
          onChange={(value) => {
            setAtThisMoment(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'at-this-moment',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Im ready'}>{t('onboarding.atThisMoment.options.ready')}</Option>
          <Option value={'Feeling hopeful'}>{t('onboarding.atThisMoment.options.hopeful')}</Option>
          <Option value={'Im cautious'}>{t('onboarding.atThisMoment.options.cautious')}</Option>
          <Option value={'Taking it easy'}>{t('onboarding.atThisMoment.options.easy')}</Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
